<template>
  <div class="fresh">
    <div
      :value="value"
      @click="$emit('click')"
      @focus="$emit('onFocus')"
      @input="$emit('input', $event.target.value)"
      :class="{ error: error, vertical: vertical, container: !vertical }"
    >
      <slot />
    </div>
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
      <p>{{ error }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "CustomInputGroup",
  props: ["value", "name", "analyticsTypology", "vertical"],
  mounted() {
    this.updateValues();
  },
  updated() {
    this.updateValues();
  },
  methods: {
    // Compatibilidad con Safari, por alguna razon no captura el evento 'input'
    onRadioClick(val) {
      this.$emit("input", val);
    },
    updateValues() {
      // Para cada elemento en el slot
      this.$slots.default.forEach(val => {
        // Busco su funcion getValue
        if (val.componentInstance && val.componentInstance.getValue) {
          // Y si el elemento dice que su valor, es igual al valor que tengo como wrapper, lo marco, ya que se está dibujando
          if (this.value === val.componentInstance.getValue()) {
            // ??????
            val.componentInstance.setChecked();
          }
        }
      });
    }
  }
};
</script>

<style scoped>
div.container {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 0px;
  height: 56px;
  padding-left: 13px;
  padding-right: 13px;
}
div.vertical {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}
div.fresh {
  margin-bottom: 24px;
}

/* optional styles, I'm using this for centering radiobuttons */
.input-container {
  display: inline-flex;
  align-items: center;
  width: 50%;
  height: 100%;
}

/* Estilo para errores */
div.container.error {
  background: #fcdfdf;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}
</style>
